import { useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import Loader from "../../elements/Loader";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function CampaignListing() {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchCampaigns();
    }, []);

    const fetchCampaigns = async () => {
        setLoading(true);
        ApiService.get('promotion/campaigns').then((response) => {
            setLoading(false);
            setCampaigns(response.data);
        }).catch((err) => {
            setLoading(false);
            toast.error("Failed to fetch campaigns");
        });
    };

    return (
        <div className="row">
            <div className="col-xl-12">
                {loading && <Loader />}
                <div className="card dz-card" id="bootstrap-table2">
                    <div className="card-header flex-wrap d-flex justify-content-between border-0">
                        <div>
                            <h4 className="card-title">Campaign List</h4>
                        </div>
                        <ul className="nav nav-tabs dzm-tabs">
                            <li className="nav-item" role="presentation">
                                <Link to="/add-campaign" className="btn btn-primary">
                                    Add Campaign
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-responsive-md">
                                <thead>
                                    <tr>
                                        <th><strong>Sr No.</strong></th>
                                        <th><strong>Name</strong></th>
                                        <th><strong>Description</strong></th>
                                        <th><strong>Budget</strong></th>
                                        <th><strong>Status</strong></th>
                                        <th><strong>Action</strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {campaigns && campaigns.length > 0 && campaigns.map((campaign, index) => (
                                        <tr key={campaign.id}>
                                            <td><strong>{index + 1}</strong></td>
                                            <td>{campaign.name}</td>
                                            <td>{campaign.description}</td>
                                            <td>{campaign.budget}</td>
                                            <td>{campaign.status}</td>
                                            <td>
                                                <Link
                                                    to={`/edit-campaign/${campaign.id}`}
                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                >
                                                    <i className="fa fa-pencil" />
                                                </Link>

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}